import HTTPRequest from '../controllers/httpRequest';
import secureStorage from '../controllers/secureStorage';

const tokenHandler = {
  async refreshS3Token() {
    const response = await HTTPRequest.postRequest(
      '/api/auth/token/refresh/s3_uploader',
      {}
    );

    if (response.upload_token) {
      secureStorage.setItem('uploadToken', response.upload_token);
      console.log('New upload token generated');
      return true;
    }

    return false;
  }
};

export default tokenHandler;
